import { AuthShell, authErrorCopy, LoginForm } from '@skylabs-digital/backoffice-kit';
import { useAccessDecision, useLoginFlow } from '@skylabs-digital/react-identity-access';
import { Navigate } from 'react-router-dom';

/**
 * El login sobre `useLoginFlow` de RIA y el `AuthShell`/`LoginForm` del kit.
 * El navegador manda SOLO `{ identifier, password }` a `/api/bo/auth/login`;
 * el `app_id` y el contexto `(platform, admin)` los pone el BFF. La
 * redirección sale de `useAccessDecision` con EL MISMO preset que
 * `ProtectedRoute`, así no hay rebote posible.
 */
export function LoginPage() {
  const access = useAccessDecision({ preset: 'platformAdmin' });
  const { submit, status, error } = useLoginFlow();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
      </div>
    );
  }
  if (access.status === 'allowed') return <Navigate to="/apps" replace />;

  return (
    <AuthShell title="Fisto" subtitle="Sign in to the files backoffice">
      <LoginForm
        onSubmit={submit}
        submitting={status === 'submitting'}
        errorMessage={authErrorCopy(error)}
      />
    </AuthShell>
  );
}
